import { Box, Button, Grid, List, ListItem, Skeleton, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Circle } from '@mui/icons-material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
// import IconButton from '@mui/material/IconButton';
// import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
// import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import getConfig from 'next/config';
import styles from './styles';
import EirLoader from '../eir-loader/EirLoader';
import getGeneralImage from '../../../util/getGeneralImage';
// import useLocalStorage from '../../hooks/useLocalStorage';
const { publicRuntimeConfig } = getConfig();

const EirSingleCardBody = ({
  offerSelected,
  sash,
  title,
  loading,
  description,
  priceIncreaseTagline = [''],
  descriptions,
  openDialog,
  price,
  contractLength,
  // afterPrice,
  // noDiscount,
  selectButton,
  index,
  offer,
  // switchTheme,
  color,
  // showCounter = false,
  // offerCount,
  code,
  showLoader,
  // onOfferSelect,
  // onOfferUnSelect,
  isTv = false,
  isBroadband = false,
  // isMobile = false,
  handsetPrice,
  offerCardButtonDisable = false,
  isAddon,
  cmsData,
}) => {
  const theme = useTheme();
  // const localStore = useLocalStorage();

  const [priceData, setPriceData] = useState('');
  const [price1, price2] = priceData;

  const handleOfferButton = () => {
    selectButton.action(index, offer);
  };

  useEffect(() => {
    if (price) {
      setPriceData(price.toString().split('.'));
    }
  }, [price]);

  return (
    <Box sx={{ height: '100%' }}>
      {!loading ? (
        <Box sx={{ height: '100%' }}>
          {sash && sash?.length > 0 && (
            <Box
              sx={{
                ...(isTv
                  ? styles(theme, color)?.contractSingleTagSelected
                  : styles(theme, color)?.contractSingleTag),
              }}
            >
              <Typography
                variant='body1'
                sx={
                  isTv
                    ? styles(theme)?.contractSingleTagSelected?.contractSingleText
                    : styles(theme)?.contractSingleTag?.contractSingleText
                }
                className='swiper-no-swiping'
              >
                <span dangerouslySetInnerHTML={{ __html: sash }} />
              </Typography>
            </Box>
          )}
          <Box sx={styles(theme)?.singleBodycontainer}>
            {title && (
              <Typography variant='h4' sx={styles(theme).offerTitle}>
                {title}
              </Typography>
            )}
            {description && description?.length > 0 && (
              <List sx={styles(theme)?.singleDescriptionList} dense>
                {description.map((list, i) => (
                  <ListItem key={i} sx={styles(theme)?.singleDescriptionList?.item}>
                    <Stack
                      direction='row'
                      alignItems='center'
                      sx={{
                        background: theme.palette.secondary.contrastText,
                        width: '100%',
                        borderRadius: '6px',
                        alignItems: 'center',
                        gap: '3%',
                        height: '38px',
                      }}
                    >
                      {list.icon ? (
                        <Box
                          className='item-icon'
                          component='img'
                          src={list.icon}
                          sx={{
                            height: 32,
                            width: 32,
                          }}
                        />
                      ) : (
                        <Box
                          component='img'
                          src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
                            getGeneralImage({
                              generalImageArray: cmsData?.GeneralImage_Broadband,
                              key: 'giftIcon',
                              view: 'DesktopViewImage',
                            }).url
                          }`}
                          alt='gift Icon'
                          style={{ width: '20px', height: '20px', marginLeft: '1rem' }}
                        />
                      )}
                      <Typography
                        component='p'
                        variant='body1'
                        className='text-item swiper-no-swiping'
                        sx={{ pl: 1, color: theme.palette.primary.textColor3 }}
                      >
                        <span dangerouslySetInnerHTML={{ __html: list }} />
                      </Typography>
                    </Stack>
                  </ListItem>
                ))}
              </List>
            )}
            {descriptions && descriptions?.length > 0 && (
              <List sx={styles(theme)?.singleDescriptionList} dense>
                {descriptions.map((list, i) => (
                  <ListItem key={i} sx={styles(theme)?.singleDescriptionList?.item}>
                    <Stack direction='row' alignItems='center' sx={{ width: '100%' }}>
                      {list.icon ? (
                        <Box
                          className='item-icon'
                          component='img'
                          src={list.icon}
                          alt=''
                          sx={{
                            height: 32,
                            width: 32,
                          }}
                        />
                      ) : (
                        <Circle
                          sx={{ height: 5, width: 5, color: theme.palette[color].offerMain }}
                        />
                      )}
                      {list?.value.includes('tvChannelPopup') ? (
                        <Typography
                          component='p'
                          variant='body1'
                          className='text-item swiper-no-swiping'
                          sx={{ pl: 1, color: theme.palette.primary.textColor3 }}
                          onClick={() => {
                            openDialog();
                          }}
                        >
                          <span dangerouslySetInnerHTML={{ __html: list?.value }} />
                          {/* {list?.value} */}
                        </Typography>
                      ) : (
                        <Typography
                          component='p'
                          variant='body1'
                          className='text-item swiper-no-swiping'
                          sx={{ pl: 1, color: theme.palette.primary.textColor3 }}
                        >
                          <span dangerouslySetInnerHTML={{ __html: list?.value }} />
                          {/* {list?.value} */}
                        </Typography>
                      )}
                    </Stack>
                  </ListItem>
                ))}
              </List>
            )}
            <Grid container sx={{ height: 'auto', pb: '16px' }}>
              <Grid
                item
                xs={12}
                md={7}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end',
                  flexDirection: 'column',
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                  {isTv || isAddon ? (
                    <Typography
                      component='span'
                      variant='h4'
                      sx={
                        isBroadband
                          ? {
                              ...styles(theme).singlePriceOne,
                              color: theme.palette.primary.textColor3,
                            }
                          : styles(theme).singlePriceOne
                      }
                      className='swiper-no-swiping'
                    >
                      {price1 ? `+ €${price1}` : ''}
                    </Typography>
                  ) : (
                    <Typography
                      component='span'
                      variant='h4'
                      sx={
                        isBroadband
                          ? {
                              ...styles(theme).singlePriceOne,
                              color: theme.palette.primary.textColor3,
                            }
                          : styles(theme).singlePriceOne
                      }
                      className='swiper-no-swiping'
                    >
                      {price1 ? `€${price1}` : ''}
                    </Typography>
                  )}

                  <Typography
                    component='span'
                    variant='h4'
                    sx={
                      isBroadband
                        ? {
                            ...styles(theme).singlePriceOne,
                            color: theme.palette.primary.textColor3,
                          }
                        : styles(theme).singlePriceOne
                    }
                    className='swiper-no-swiping'
                  >
                    {price2 ? `.${price2}` : ''}
                  </Typography>
                  {/* {noDiscount && ( */}
                  {/* {isTv && (
                    <Typography
                      component='p'
                      sx={styles(theme).singleContractTextAMonth}
                      className='swiper-no-swiping'
                    >
                      / month
                    </Typography>
                  )}
                  {/* ) } */}
                  <Typography
                    component='p'
                    variant='inputLabel'
                    sx={styles(theme)?.singleContractText}
                    className='swiper-no-swiping'
                  >
                    {contractLength}
                  </Typography>
                </Box>
                {/* {!isTv && ( */}

                {/* // )} */}
                {/* {!noDiscount && contractLength && (
                  <Typography
                    component='p'
                    sx={styles(theme)?.singleContractText}
                    className='swiper-no-swiping'
                  >
                    {contractLength}
                  </Typography>
                )} */}
                {/* promotion texts */}
                {/* {!noDiscount && afterPrice && (
                  <Typography
                    component='p'
                    sx={styles(theme)?.singlePromotionText}
                    className='swiper-no-swiping'
                  >
                    {afterPrice}
                  </Typography>
                )} */}
              </Grid>
              <Grid item xs={5} sx={styles(theme)?.singleButtonContainer}>
                <Box>
                  {!(showLoader === code) && selectButton && (
                    <Button
                      variant='buttonMedium'
                      disabled={offerCardButtonDisable}
                      onClick={handleOfferButton}
                      aria-label={offerSelected ? `${title} plan selected` : `Select ${title} plan`}
                      sx={{
                        ...styles(theme)?.singleSelectButton,
                        ...(offerSelected ? styles(theme).singleCtaSelected : {}),
                      }}
                    >
                      {!offerSelected ? selectButton?.title : 'Selected'}
                      {offerSelected ? (
                        <CheckCircleOutlineOutlinedIcon sx={styles(theme).singleCtaCheck} />
                      ) : (
                        ''
                      )}
                    </Button>
                  )}
                  {!isTv && !isAddon
                    ? showLoader === code && (
                        <EirLoader
                          loaderTitle='Adding'
                          buttonSize={{ width: '9.6rem', height: '2.8rem' }}
                        />
                      )
                    : showLoader === code && (
                        <EirLoader
                          loaderTitle={!offerSelected ? 'Adding' : 'Removing'}
                          buttonSize={{ width: '9.6rem', height: '2.8rem' }}
                        />
                      )}
                </Box>
              </Grid>
            </Grid>
            {/* show phone cost when handset is int cart */}
            {handsetPrice > 0 && (
              <Typography variant='body1' sx={styles(theme).brandPriceText}>
                Phone cost:&nbsp;
                <Typography variant='subtitle1' component='p' sx={styles(theme).brandPrice}>
                  {`€${(handsetPrice / 100).toFixed(2)}`}
                </Typography>
              </Typography>
            )}
            {/* {description.length > 0 && ( */}
            {priceIncreaseTagline?.length > 0 && (
              <Typography
                component='p'
                variant='inputLabel'
                sx={
                  isTv || isAddon
                    ? {
                        ...styles(theme).priceIncreaseTagline,
                        marginBottom: 0,
                        paddingBottom: isAddon ? 0 : '1.5rem',
                      }
                    : styles(theme).priceIncreaseTagline
                }
                className='swiper-no-swiping'
              >
                <span dangerouslySetInnerHTML={{ __html: priceIncreaseTagline[0] }} />
                {/* {priceIncreaseTagline} */}
              </Typography>
            )}
            {/* )} */}
            {/* {showCounter &&
              offerCount > 0 &&
              localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'true' && (
                <Box
                  style={{
                    marginTop: '0.5rem',
                  }}
                >
                  <Typography
                    component='p'
                    sx={styles(theme).addedSimText}
                    className='swiper-no-swiping'
                  >
                    <strong>{offerCount} ×</strong> Plan already added
                  </Typography>
                </Box>
              )} */}
          </Box>
          {/* {showCounter &&
            offerCount > 0 &&
            localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'true' && (
              <Box
                style={{
                  marginTop: '-1rem',
                }}
              >
                <Typography
                  component='p'
                  sx={styles(theme).addedSimText}
                  className='swiper-no-swiping'
                >
                  <strong>{offerCount} ×</strong> Plan already added
                </Typography>
              </Box>
            )} */}
        </Box>
      ) : (
        <>
          <Skeleton style={{ top: '-1rem', position: 'relative', height: '3rem', width: '100%' }} />
          <Skeleton height={20} width='60%' sx={{ marginX: 'auto', marginTop: '1.2rem' }} />
          <Stack direction='row' sx={{ marginTop: '1rem', gap: '3%', marginX: '1.5rem' }}>
            <Skeleton variant='circular' width={18} height={18} />
            <Skeleton height='1.2rem' width='85%' />
          </Stack>

          <Stack direction='row' sx={{ marginTop: '0.5rem', gap: '3%', marginX: '1.5rem' }}>
            <Skeleton variant='circular' width={18} height={18} />
            <Skeleton height='1.2rem' width='70%' />
          </Stack>
          <Stack direction='row' sx={{ marginTop: '0.5rem', gap: '3%', marginX: '1.5rem' }}>
            <Skeleton variant='circular' width={18} height={18} />
            <Skeleton height='1.2rem' width='85%' />
          </Stack>

          <Stack
            direction='row'
            sx={{ marginTop: '2rem', gap: '10%', marginX: '1.5rem', alignItems: 'center' }}
          >
            <Skeleton variant='rectangular' width='100%' height={18} />
            <Skeleton height='4rem' width='60%' />
          </Stack>
        </>
      )}
    </Box>
  );
};
export default EirSingleCardBody;
